<!-- 微信扫码生成二维码 -->
<template>
  <div id="login_container"></div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  mounted() {
   this.getErWerMa();
  },
  props: {
    url: String,
  },  
  methods: {
    getErWerMa() {
      var redirect_uri=this.$ctxPath+this.url
      var href =
        "data:text/css;base64,Ym9keXsNCiAgICBtYXJnaW46MDsNCn0NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZSFpbXBvcnRhbnQ7fQ0KLmltcG93ZXJCb3ggLnFyY29kZXsNCiAgICB3aWR0aDoyMzBweDsNCiAgICBtYXJnaW46MDsNCn0NCi5pbXBvd2VyQm94IC5pbmZvew0KICAgIGRpc3BsYXk6IG5vbmUgIWltcG9ydGFudDsNCn0NCi5vbGQtdGVtcGxhdGV7DQogICAgd2lkdGg6IDEwMCU7DQogICAgZGlzcGxheTogZmxleDsNCiAgICBhbGlnbi1pdGVtczogY2VudGVyOw0KfQ0KaWZyYW1lew0KICB3aWR0aDoxMDAlICFpbXBvcnRhbnQ7DQogIGhlaWdodDogMTAwJSAhaW1wb3J0YW50Ow0KfQ0K";
      var obj = new WxLogin({
        self_redirect: true,
        id: "login_container",
        appid: "wx40a5943a8676ec2b",
        scope: "snsapi_login",
        redirect_uri: encodeURIComponent(redirect_uri),
        state: Math.ceil(Math.random() * 1000),
        style: "white",
        href: href,
      });
    },
  },
};
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>